define(
  'modules/localisation',
  [
    'jquery'
  ],
  function (
    $
  ) {
    'use strict';

    var selectors = {
      localLinkParentNode: '.js-local-link-parent'
    };

    function init (config) {
      localiseText(config);
      localiseLinks(config);
    }

    function localiseText (config) {

      var localizationElements = document.body.querySelectorAll('[data-local-text]');

      for (var index = 0; index < localizationElements.length; index++) {
        var element = localizationElements[index]
          , text = config.manifest.text.static[ element.dataset.localText ]
          , removeSelector = element.dataset.removeIfEmpty;

        if ( text ) {

          element.innerText = text;

        } else if ( removeSelector ) {

          $(element).parents(removeSelector).remove();

        }
      }
    }

    function localiseLinks (config) {
      var localizationLinkElements = document.body.querySelectorAll('[data-local-link]');

      for (var index = 0; index < localizationLinkElements.length; index++) {
        var element = localizationLinkElements[index]
          , url = config.manifest.links[ element.dataset.localLink ];

        if ( url ) {
          element.href = url;
        } else if ( url === '' ) {
          $(element).closest(selectors.localLinkParentNode).remove();
        }
      }
    }

    return {
      init: init
    }
});
